module.exports = __webpack_public_path__ + "img/0Q3B8360-70_H.7a7009ff.webp";